module.exports = __webpack_public_path__ + "img/family.b8f7df75.svg";